export const FETCH_SITE = 'views/users/FETCH_SITE'
export const USER_SITE = 'views/users/USER_SITE'
